import {
  RESET_FILTERDATA,
  RESET_FILTER_CONFIG,
  SET_FILTERDATA,
  SET_FILTER_CONFIG,
  RESET_SELECTED_MONTH_RANGE,
  SET_SELECTED_MONTH_RANGE,
} from '../../constants';

export const setFilterDataState = (filterData) => ({
  type: SET_FILTERDATA,
  payload: filterData,
});

export const resetFilterDataState = () => ({
  type: RESET_FILTERDATA,
});

export const setFilterConfig = (filterConfig) => ({
  type: SET_FILTER_CONFIG,
  payload: filterConfig,
});

export const resetFilterConfig = () => ({
  type: RESET_FILTER_CONFIG,
  payload: [],
});

export const setSelectedMonthRangeState = (monthRange) => ({
  type: SET_SELECTED_MONTH_RANGE,
  data: { selectedRange: monthRange },
});

export const resetSelectedMonthRange = () => ({
  type: RESET_SELECTED_MONTH_RANGE,
  payload: [],
});
